// extracted by mini-css-extract-plugin
export var button = "_6i-0";
export var icon = "_6i-1";